// extracted by mini-css-extract-plugin
export var cardHeader = "_fg-0";
export var reorderHandle = "_fg-3";
export var titleArea = "_fg-1";
export var titleAreaWithHandle = "_fg-2";